import Vue from 'vue';
import axios from 'axios';

export const SAVE_FIELD_LABELS = 'SAVE_FIELD_LABELS';
export const SAVE_FIELD_LABELS_RAW = 'SAVE_FIELD_LABELS_RAW';
export const SAVE_FIELD_LENGTHS = 'SAVE_FIELD_LENGTHS';

const reducer = (obj, curr) => ({
  ...obj,
  [`${curr.field.group}:${curr.personType.code}:${curr.purpose === 'DMATCH' ? 'DIRECTMATCH' : curr.purpose}:${curr.field.code}`]: curr.customLabel ? curr.customLabel : curr.field.name,
});

const lengths = (obj, curr) => ({
  ...obj,
  [`${curr.field.group}:${curr.personType.code}:${curr.purpose === 'DMATCH' ? 'DIRECTMATCH' : curr.purpose}:${curr.field.code}`]: curr.customLength ? curr.customLength : curr.field.length,
});

export default {
  namespaced: true,
  state: {
    loaded: false,
    fieldLabels: {},
    fieldLabelsRaw: [],
    fieldLengths: {},
  },
  actions: {
    init({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get('/field-mappings');
          commit(SAVE_FIELD_LABELS_RAW, res.data);
          commit(SAVE_FIELD_LABELS, res.data.reduce(reducer, {}));
          commit(SAVE_FIELD_LENGTHS, res.data.reduce(lengths, {}));
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  mutations: {
    [SAVE_FIELD_LABELS](state, fieldLabels) {
      Vue.set(state, 'fieldLabels', fieldLabels);
      Vue.set(state, 'loaded', true);
    },
    [SAVE_FIELD_LABELS_RAW](state, fieldLabelsRaw) {
      Vue.set(state, 'fieldLabelsRaw', fieldLabelsRaw);
    },
    [SAVE_FIELD_LENGTHS](state, fieldLengths) {
      Vue.set(state, 'fieldLengths', fieldLengths);
    },
  },
  getters: {
    getFieldLabel: state => code => state.fieldLabels[code],
    getFieldLabelsByGroup: state => purpose => state.fieldLabelsRaw
      .filter(l => l.purpose === purpose)
      .map(l => l.field)
      .sort((f1, f2) => f1.code.sort - f2.code.sort),
    getFieldLabelByPersonType: state => (code, purpose, personType) => {
      const result = state.fieldLabelsRaw
        .filter(e => e.field.code === code
        && e.purpose === purpose
        && e.personType.code === personType)
        .map(item => (item.customLabel ? item.customLabel : item.field.name)).toString();
      return result;
    },
    getFieldLengthsByPersonType: state => (code, purpose, personType) => {
      const result = state.fieldLabelsRaw
        .filter(e => e.field.code === code
        && e.purpose === purpose
        && e.personType.code === personType)
        .map(item => (item.customLength ? item.customLength : item.field.length)).toString();
      return result;
    },
    getFieldEnabledForPersonType: state => (code, purpose, personType) => {
      const result = state.fieldLabelsRaw.filter(e => e.field.code === code
        && e.purpose === purpose
        && e.enabled
        && e.personType.code === personType);
      return result.length > 0;
    },
    getEnabledFieldNamesForPersonType: state => (code, purpose, personType) => {
      const enabledFields = state.fieldLabelsRaw.filter(e => e.field.code === code
        && e.purpose === purpose
        && e.enabled
        && e.personType.code === personType);
      return enabledFields.map(field => field.field.name);
    },

    getFieldRequiredForPersonType: state => (code, purpose, personType) => {
      const result = state.fieldLabelsRaw.filter(r => r.field.code === code
        && r.purpose === purpose
        && r.enabled
        && r.required
        && r.personType.code === personType);
      return result.length > 0;
    },
  },
};
